import template from './wizard_leave_setup_cycle.html';

class WizardLeaveSetupCycle
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.disable_edit = ko.observable(false);
		this.leave_type_id = ko.observable(null);

		//leave cycle details to be saved
		this.cycle_length_number = ko.observable(30);
		this.cycle_length_text = ko.observable();
		this.cycle_amount = ko.observable(1.5);
		this.is_earned = ko.observable(true);
		this.is_capping_active = ko.observable(true);
		this.capped_amount = ko.observable(25);
		this.is_switch_type = ko.observable(false);
	}

	close()
	{
		this.dialog.close();
	}

	async back_wizard()
	{
		this.dialog.close();

		if (this.leave_type_id())
			return;

		let leave_object = Object.assign(this.dialog.bindings.data.leave_object,
			{capped_amount: this.capped_amount(),
			is_capping_active: this.is_capping_active(),
			is_earned: this.is_earned(),
			is_switch_type: this.is_switch_type(),
			cycle_amount: this.cycle_amount(),
			cycle_length_text: this.cycle_length_text(),
			cycle_length_number: this.cycle_length_number()}
		)

		await Grape.dialog.open('WizardLeaveSetupDescription', leave_object);
	}
}

class WizardLeaveSetupCyclePage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new WizardLeaveSetupCycle(this);
	}

	init()
	{
		//if cycle length is given (i.e. "1 year") then split it up
		if (this.bindings.leave_object.cycle_length)
		{
			let length_array = this.bindings.leave_object.cycle_length.split(" ");
			this.bindings.leave_object.cycle_length_number =  parseInt(length_array[0]);
			this.bindings.leave_object.cycle_length_text = length_array[1];
		}

		this.viewModel.is_switch_type(this.bindings?.leave_object?.is_switch_type || false);
		this.viewModel.is_capping_active(this.bindings?.leave_object?.is_capping_active || false);
		this.viewModel.is_earned(this.bindings?.leave_object?.is_earned || false);

		//Apply bindings if they exist (going back a page)
		this.viewModel.cycle_length_number(this.bindings?.leave_object?.cycle_length_number || 30);
		this.viewModel.cycle_length_text(this.bindings?.leave_object?.cycle_length_text);
		this.viewModel.cycle_amount(this.bindings?.leave_object?.cycle_amount || 1.5);
		this.viewModel.capped_amount(this.bindings?.leave_object?.capped_amount || 25);

		let length_text = this.bindings?.leave_object?.cycle_length_text || 'days';

		if (length_text == 'day')
		{
			this.bindings.leave_object.cycle_length_text = 'days';
			this.viewModel.cycle_length_text('days');
		}
		else if (length_text == 'mon')
		{
			this.bindings.leave_object.cycle_length_text = 'mons';
			this.viewModel.cycle_length_text('mons');
		}
		else if (length_text == 'years')
		{
			this.bindings.leave_object.cycle_length_text = 'year';
			this.viewModel.cycle_length_text('year');
		}

		if (!this.bindings.leave_object.disable_edit)
			this.viewModel.disable_edit(false);
		else
			this.viewModel.disable_edit(true);

		if (this.bindings.leave_type_id)
			this.viewModel.leave_type_id(this.bindings.leave_type_id);
	}

	next_wizard(v, e)
	{
		let message = '';
		let valid = true;

		if (!this.viewModel.cycle_amount() || this.viewModel.cycle_amount() <= 0)
		{
			message = tr('Please enter a cycle amount greater than or equal to 1');
			valid = false
		}
		else if (!this.viewModel.cycle_length_number() || this.viewModel.cycle_length_number() <= 0)
		{
			message = tr('Please enter a cycle length greater than or equal to 1');
			valid = false;
		}
		else if ((this.viewModel.is_capping_active() == true && !this.viewModel.capped_amount()) || this.viewModel.capped_amount() <= 0)
		{
			message = tr('Please enter a capping amount greater than or equal to 1 (if capping is active)');
			valid = false;
		}

		if (valid == false)
		{
			Grape.alerts.alert({type: 'error', message: message, title: tr('Error')});
			return;
		}

		let data = Object.assign(this.bindings.leave_object, {
			capped_amount: this.viewModel.capped_amount(),
			is_capping_active: this.viewModel.is_capping_active(),
			is_earned: this.viewModel.is_earned(),
			is_switch_type: this.viewModel.is_switch_type(),
			cycle_amount: this.viewModel.cycle_amount(),
			cycle_length_text: this.viewModel.cycle_length_text(),
			cycle_length_number: this.viewModel.cycle_length_number()
		});
		
		this.close();
		Grape.dialog.open('WizardLeaveSetupRoles', this.bindings);
	}

	async back_and_save()
	{
		this.bindings.leave_object.capped_amount = this.viewModel.capped_amount();
		this.bindings.leave_object.is_capping_active = this.viewModel.is_capping_active();
		this.bindings.leave_object.is_earned = this.viewModel.is_earned();
		this.bindings.leave_object.cycle_amount = this.viewModel.cycle_amount();
		this.bindings.leave_object.cycle_length_text = this.viewModel.cycle_length_text();
		this.bindings.leave_object.cycle_length_number = this.viewModel.cycle_length_number();
		this.bindings.leave_object.is_switch_type = this.viewModel.is_switch_type();

		this.close();
		let res = await Grape.fetches.postJSON('/admin/leave_type/save', this.bindings.leave_object);
		
		if (res.status === 'OK')
		{
			await Grape.alerts.alert({'type': 'success', 'message': tr('Changes has been saved'), 'title': tr('Success')});
			this.close();
		}
	}

	is_capping_active_and_disabled_edit()
	{
		return this.viewModel.is_capping_active() && !this.viewModel.disable_edit()
	}

	leave_type_id_and_disabled_edit()
	{
		return this.viewModel.leave_type_id() && !this.viewModel.disable_edit()
	}
}

export default {
	name: 'WizardLeaveSetupCycle',
	dialog_class: WizardLeaveSetupCyclePage,
	template: template,
	template_filename: 'translation/dialogs/wizard_leave_setup_cycle',
	provider: 'ps'
};
